import { render, staticRenderFns } from "./BCOptionalFeaturesPowerOnMode.vue?vue&type=template&id=0c3dbf0c&scoped=true"
import script from "./BCOptionalFeaturesPowerOnMode.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesPowerOnMode.vue?vue&type=script&lang=js"
import style0 from "./BCOptionalFeaturesPowerOnMode.vue?vue&type=style&index=0&id=0c3dbf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3dbf0c",
  null
  
)

export default component.exports